import { Image } from 'expo-image';
import { Link } from 'expo-router';
import { Pressable, StyleSheet, View } from 'react-native';

export type DoublePointsMondayBannerProps = {
  bannerImageUrl: string;
  onPress?: () => void;
  testID?: string;
};

export function DoublePointsMondayBanner({
  bannerImageUrl,
  onPress,
  testID = 'double-points-monday-banner',
}: DoublePointsMondayBannerProps) {
  return (
    <Link href="/menu" asChild>
      <Pressable testID={testID} style={styles.container} onPress={onPress}>
        <View style={styles.imageContainer}>
          <Image
            source={{ uri: bannerImageUrl }}
            style={styles.image}
            contentFit="cover"
          />
        </View>
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  imageContainer: {
    width: '100%',
    height: 125,
    borderRadius: 8,
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
  },
});
